import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/services/user.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-our-founders',
  templateUrl: './our-founders.component.html',
  styleUrls: ['./our-founders.component.scss']
})
export class OurFoundersComponent implements OnInit {
  
  virgilReadMoreExpanded: boolean = false;
  michaelReadMoreExpanded: boolean = false;
  marvReadMoreExpanded: boolean = false;
  bradReadMoreExpanded: boolean = false;
  mikeReadMoreExpanded: boolean = false;
  
  constructor(
    public userService: UserService,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Our Founders - Tangerine.fun');
    window.scrollTo(0, 0);
  }

  toggleVirgilReadMore() {
    this.virgilReadMoreExpanded = !this.virgilReadMoreExpanded;
  }

  toggleMichaelReadMore() {
    this.michaelReadMoreExpanded = !this.michaelReadMoreExpanded;
  }

  toggleMarvReadMore() {
    this.marvReadMoreExpanded = !this.marvReadMoreExpanded;
  }

  toggleBradReadMore() {
    this.bradReadMoreExpanded = !this.bradReadMoreExpanded;
  }

  toggleMikeReadMore() {
    this.mikeReadMoreExpanded = !this.mikeReadMoreExpanded;
  }

  isLoggedIn() {
    if (
      Object.keys(this.userService.userServiceModal.customerData).length &&
      this.userService.userServiceModal.customerData.CustomerId &&
      this.userService.checkIfUserAuthenticatedOrNot()
    ) {
      return true;
    } else {
      return false;
    }
  }
}